import Info from 'components/Info'
import { Error, InfoRedStyle, Row, ValidButton } from '../ProductListTable.definitionFields'
import { ProductCreation } from '@Arti-zen/package-backoffice'

type TProps = {
  givenCoef: string | number
  expectedCoef: number
  errorMessage: string
  correctProduct: (corrections: Partial<ProductCreation>) => void
}

export default function CoefProductErrorTable({ givenCoef, expectedCoef, errorMessage, correctProduct }: TProps) {
  const chooseExpectedCoef = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    correctProduct({ coef: expectedCoef })
  }

  return (
    <Row>
      <Error>{givenCoef ? `${givenCoef}%` : '0 %'}</Error>
      <ValidButton onClick={chooseExpectedCoef}>{expectedCoef} %</ValidButton>
      <Info text={errorMessage} style={InfoRedStyle} />
    </Row>
  )
}
